import { useState, useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { DemoBadge } from "@/components/common";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { GraduationCap, PlayCircle } from "lucide-react";

export default function Academy() {
  const [courses, setCourses] = useState([]);
  const [progress, setProgress] = useState({});
  useEffect(() => { api.get("/academy/courses").then((r) => setCourses(r.data)); }, []);

  const cats = Array.from(new Set(courses.map((c) => c.category)));
  const toggle = (id) => setProgress((p) => ({ ...p, [id]: Math.min((p[id] || 0) + 25, 100) }));

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-lg bg-xd-green/20 text-xd-green"><GraduationCap size={22} /></span>
          <div><h1 className="font-heading text-4xl font-black tracking-tight">XD Academy</h1><p className="text-xd-muted">Learn the hotshot business — from LLC to fleet growth.</p></div>
        </div>

        {cats.map((cat) => (
          <div key={cat} className="mt-10">
            <h2 className="font-heading text-xl font-bold mb-4">{cat}</h2>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {courses.filter((c) => c.category === cat).map((c) => {
                const pct = progress[c.id] || 0;
                return (
                  <div key={c.id} data-testid={`course-${c.id}`} className="bg-xd-paper border border-xd-border rounded-xl p-6 flex flex-col hover:border-xd-green/50 transition-colors">
                    <div className="flex items-center justify-between">
                      <span className="text-[10px] uppercase tracking-wide font-bold text-xd-green bg-xd-green/10 border border-xd-green/30 rounded px-2 py-0.5">{c.level}</span>
                      <span className="text-xs text-xd-dim">{c.lessons} lessons</span>
                    </div>
                    <h3 className="mt-3 font-heading text-lg font-bold leading-tight">{c.title}</h3>
                    <div className="mt-4">
                      <div className="flex justify-between text-xs text-xd-dim mb-1"><span>Progress</span><span>{pct}%</span></div>
                      <Progress value={pct} className="h-2 bg-xd-border" />
                    </div>
                    <Button data-testid={`course-start-${c.id}`} onClick={() => toggle(c.id)} className="mt-4 bg-xd-surface hover:bg-xd-border text-white" size="sm">
                      <PlayCircle size={16} className="mr-2" /> {pct === 0 ? "Start" : pct === 100 ? "Completed" : "Continue"}
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
